import { createRouter, createWebHistory } from 'vue-router';

export const projectsViewRoute = {
	path: '/projects/view/:projectId*',
	name: 'projectsView',
	component: () => import('@/pages/projects/ProjectsView.vue'),
};

export const welcomeRoute = {
	path: '/welcome',
	name: 'welcome',
	component: () => import('@/pages/welcome/WelcomeIndex.vue'),
};

const router = createRouter({
	history: createWebHistory(),
	routes: [
		projectsViewRoute,
		welcomeRoute,

		// route level code-splitting
		// this generates a separate chunk (About.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		// component: () => import('../pages/AboutView.vue'),
	],
});

router.afterEach((to, from) => {
	if (from.path == '/' || from.fullPath == to.fullPath) {
		return;
	}
	window.dispatchEvent(new CustomEvent('scoro-base-amplitude-page-view'));
});

export default router;
